import checkRoles from "@beeldit/user-and-access/auth/services/checkRoles";
import projectWidgets from "@main/projectWidgets";

const filterUIConfig = {
  uiScheme: {
    "ui:classNames": "filters-container",
    search: {
      "ui:options": {
        label: false, // Oculta el título del campo
        placeholder: "Buscar...",
      },
    },
    category_id: {
      "ui:widget": "category-selector",
      "ui:options": {
        label: false, // Oculta el título del campo
      },
    },
    producer_id: {},
  },
  widgets: { ...projectWidgets },
};
const getFilterUIConfig: any = (user: any) => {
  if (checkRoles(user, ["admin"])) {
    filterUIConfig.uiScheme.producer_id = {
      "ui:widget": "producer-selector",
      "ui:options": {
        label: false, // Oculta el título del campo
      },
    };
  }
  return filterUIConfig;
};
export default getFilterUIConfig;
